import styles from "./HorseBodyMapTab.module.css";
import BodyMapManager from "../BodyMap/BodyMapManager";

const HorseBodyMapTab = ({ horse, reloadDetailHorse, lockParent }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <BodyMapManager
          reloadDetail={() => reloadDetailHorse(horse, true)}
          initialMaps={horse.bodyMaps}
          cltId={horse.clientExternalId}
          horseId={horse.externalId}
          soId={null}
          lockParent={lockParent}
        />
      </div>
    </div>
  );
};

export default HorseBodyMapTab;
